import axios from 'axios'
import { BOT_URL } from '../constants/url'

export const sentBotMessage = (message, subMessage) => {
  axios
    .post(`${BOT_URL}/message`, {
      origin: 'Pinmap pro',
      message,
      sub_message: subMessage,
      type: 'checkoutError'
    })
    .catch(err => {
      console.error(err)
    })
}

export const buildMessage = (shippingRates, cartData, companyInfo, addressInfo) => {
  const { lines, total, totalWeight } = cartData
  const { companyName } = companyInfo
  const { userAddress, district, region } = addressInfo
  let message = 'Error: '
  message += shippingRates
    ? 'Pinflag Shipping Rate did not provide a rate\n'
    : 'Shopify did not provide any rate\n'
  message += `Company: ${companyName}\n`
  message += `Address: ${userAddress}, ${district}, ${region}\n`
  message += `CartData: Total: $${total}, Weight: ${totalWeight}\n`
  for (let index = 0; index < lines.length; index++) {
    message += ` - Product ${index + 1}: id: ${lines[index].id}, name: ${lines[index].productName}, quantity: ${lines[index].quantity}\n`
  }
  const subMessage = shippingRates ? JSON.stringify(shippingRates) : ''
  return { message, subMessage }
}

export const errorMessage = (errorResponse, companyInfo, endpoint, body) => {
  const { companyName } = companyInfo
  let message = `Error: ${errorResponse?.message}\n`
  message += `Message: error calling ${endpoint}\n`
  message += `Company: ${companyName}\n`
  let subMessage = `${JSON.stringify(errorResponse)}\n`
  subMessage += body ? JSON.stringify(body) : ''
  sentBotMessage(message, subMessage)
}
